import { render, staticRenderFns } from "./ChooseJGCom.vue?vue&type=template&id=67a9e4e0&"
import script from "./ChooseJGCom.vue?vue&type=script&lang=ts&"
export * from "./ChooseJGCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports